import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

/* eslint-disable react/prop-types */
const ConfirmModal = ({ confirmModal, setConfirmModal, content, handleDeleteAction, type }) => {
	const handleClose = () => {
		setConfirmModal(false);
	};

	return (
		<div>
			<Dialog open={confirmModal} onClose={handleClose} aria-labelledby='alert-dialog-title'>
				<DialogTitle style={{color :  type ?  'red' : ""}} id='alert-dialog-title' sx={{ mt: 2 }}>
					{content.title}
				</DialogTitle>

				<DialogContent>
					<p id='alert-dialog-description'>{content.desc}</p>
				</DialogContent>

				<DialogActions
					sx={{
						mb: 2.8,
						px: 2.5,
						justifyContent: "center",
						button: {
							width: "50%",
						},
					}}>
					<Button onClick={handleClose} variant='outlined' color='error'>
						Cancel
					</Button>
					<Button onClick={handleDeleteAction} autoFocus variant='contained'>
						{content.btnText}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default ConfirmModal;
